import { render, staticRenderFns } from "./PatientEducation.vue?vue&type=template&id=67853292&scoped=true"
import script from "./PatientEducation.vue?vue&type=script&lang=js"
export * from "./PatientEducation.vue?vue&type=script&lang=js"
import style0 from "./PatientEducation.vue?vue&type=style&index=0&id=67853292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67853292",
  null
  
)

export default component.exports